<template>
    <div class="text-center w-full">
        <span
            v-if="loading"
            class="loading loading-spinner text-blue-500 inline-block" />
        <div
            v-else
            class="w-full">
            <div class="text-lg text-green-500 text-center">
                Workspace: {{ connection.workspaceDomain }}
            </div>
            <template v-if="workspaces.length > 0">
                <hts-form-select
                    v-model="workspace"
                    v-model:text="workspaceDomain"
                    :items="workspaces"
                    :clearable="false"
                    key-id="id"
                    key-label="domain"
                    label="Đổi workspace" />
                <hts-form-button
                    class="mt-2"
                    :disabled="!workspace"
                    @click="changeWorkspace">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </template>
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  connection: {
    type: Object,
    required: true
  }
})
const emits = defineEmits(['change'])
const { connection } = toRefs(props)
const selectedWorkspace = ref<any>(null)
const workspace = ref<any>(null)
const workspaceDomain = ref<any>(null)
const workspaces = ref<any[]>([])
const changing = ref<boolean>(false)
const loading = ref<boolean>(true)

const getWorkspaces = async () => {
  loading.value = true
  try {
    const response = await $api($url.company.integration.freightek.workspaces)
    const tmpData = response.data?.value?.data || []
    if (Array.isArray(tmpData)) {
      workspaces.value = tmpData
    }
  } catch (e: any) {
    //
  }
  nextTick(() => {
    loading.value = false
  })
}
onMounted(() => {
  getWorkspaces()
})

const changeWorkspace = () => {
  if (!workspace.value) {
    return
  }
  changing.value = true
  const updateData = { workspaceId: workspace.value, workspaceDomain: workspaceDomain.value }
  $api($url.company.integration.external.update, { uriParams: { ID: 'freightek' }, body: { data: updateData } })
    .then((response) => {
      workspace.value = null
      emits('change')
    })
    .finally(() => {
      changing.value = false
    })
}
</script>
